import { Component, inject } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MatDialogModule, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { Game } from '../../shared/model/game';
import { OpenSquashService } from '../../shared/services/open-squash-service';
import { MatchState } from '../../shared/model/match';

@Component({
  selector: 'app-set-match-score-component',
  imports: [CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule],
  templateUrl: './set-match-score-component.html',
  styleUrl: './set-match-score-component.scss'
})
export class SetMatchScoreComponent {
  private fb = inject(FormBuilder);
  private dialogRef = inject(MatDialogRef<SetMatchScoreComponent>);
  public data = inject(MAT_DIALOG_DATA);
  private openSquashService = inject(OpenSquashService);

  constructor() {
    console.log('-*------ SetMatchScoreComponent data:', this.data);
  }

  form: FormGroup = this.fb.group({
    games: this.fb.array(
      Array.from({ length: 5 }, (_, i) =>
        this.fb.group({
          number: [i + 1],
          player1Points: [0, Validators.min(0)],
          player2Points: [0, Validators.min(0)],
        })
      )
    )
  });

  get games() {
    return this.form.get('games') as FormArray;
  }

  submit() {
    const result: Game[] = this.form.value.games;
    console.log('resultados de los juegos:', result);
    
    let player1SetsWon = 0;
    let player1SetsLost = 0;
    let player1PointsWon = 0;
    let player1PointsLost = 0;

    let player2SetsWon = 0;
    let player2SetsLost = 0;
    let player2PointsWon = 0;
    let player2PointsLost = 0;

    result.forEach(game => {
      if (game.player1Points === game.player2Points && game.player1Points === 0) {
        return;
      }
      player1PointsWon += game.player1Points;
      player1PointsLost += game.player2Points;

      player2PointsWon += game.player2Points;
      player2PointsLost += game.player1Points;

      if (game.player1Points > game.player2Points) {
        player1SetsWon++;
        player2SetsLost++;
      } else if (game.player2Points > game.player1Points) {
        player2SetsWon++;
        player1SetsLost++;
      }
    });

    let playerGanador = null;
    if (player1SetsWon !== 0 || player2SetsWon !== 0) {
      playerGanador = player1SetsWon > player2SetsWon ? this.data.match.player1 : this.data.match.player2;
    }

    if (this.form.valid) {
      const match = {...this.data.match};
      match.games = result;
      match.playerIdWinner = playerGanador.id;

      match.player1GamesWon = player1SetsWon;
      match.player1GamesLost = player1SetsLost;
      match.player1PointsWon = player1PointsWon;
      match.player1PointsLost = player1PointsLost;

      match.player2GamesWon = player2SetsWon;
      match.player2GamesLost = player2SetsLost;
      match.player2PointsWon = player2PointsWon;
      match.player2PointsLost = player2PointsLost;

      match.state = MatchState.FINALIZADO;

      this.openSquashService.updateMatch(match).subscribe(() => {
        this.openSquashService.updateResults(match, this.data.category).subscribe();
        this.dialogRef.close(true);
      });
    }
  }

  exit() {
    this.dialogRef.close(null);
  }
}